/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	ProjectAllocationReportDTO,
	ProjectAllocationReportDTOFromJSON,
	ProjectAllocationReportDTOFromJSONTyped,
	ProjectAllocationReportDTOToJSON,
} from "./ProjectAllocationReportDTO";

/**
 *
 * @export
 * @interface ProjectAllocationReportDTOPagedResponse
 */
export interface ProjectAllocationReportDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof ProjectAllocationReportDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof ProjectAllocationReportDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof ProjectAllocationReportDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<ProjectAllocationReportDTO>}
	 * @memberof ProjectAllocationReportDTOPagedResponse
	 */
	data?: Array<ProjectAllocationReportDTO> | null;
}

export function ProjectAllocationReportDTOPagedResponseFromJSON(
	json: any
): ProjectAllocationReportDTOPagedResponse {
	return ProjectAllocationReportDTOPagedResponseFromJSONTyped(json, false);
}

export function ProjectAllocationReportDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ProjectAllocationReportDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(ProjectAllocationReportDTOFromJSON),
	};
}

export function ProjectAllocationReportDTOPagedResponseToJSON(
	value?: ProjectAllocationReportDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(ProjectAllocationReportDTOToJSON),
	};
}
